export const ru = {
    avia_class_econom: 'Эконом',
    avia_class_business: 'Бизнес',
    avia_class_comfort: 'Комфорт',
    avia_class_first: 'Первый',
};
